export const containerWidths = {
    sm: 540,
    md: 720,
    lg: 960,
    xl: 1140,
    xxl: 1320
};

export function getContainerWidth(
    breakpoint: keyof typeof containerWidths,
    span = 12
) {
    return `${(containerWidths[breakpoint] * span) / 12}px`;
}
